import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const materialInformationStatistics = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '物料类型',
            dataIndex: 'materialType',
            key: 'materialType',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.materialType || [],
        },
        {
            title: '物料名称',
            dataIndex: 'materialName',
            key: 'materialName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.materialName || [],
        },
        {
            title: '物料入库数量',
            dataIndex: 'theInboundQuantityOfTheItem',
            key: 'theInboundQuantityOfTheItem',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.theInboundQuantityOfTheItem || [],
        },
        {
            title: '物料出库数量',
            dataIndex: 'theOutboundQuantityOfTheItem',
            key: 'theOutboundQuantityOfTheItem',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.theOutboundQuantityOfTheItem || [],
        },
    ]
}
